import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HamburgerMenuService } from '@spartacus/storefront';

@Injectable({
    providedIn: 'root',
})
export class AimoHamburgerMenuService extends HamburgerMenuService {
    constructor(router: Router) {
        super(router);
    }
}
